<template>
    <div class="chart-container">
        <canvas ref="canvas"></canvas>
    </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    BarController
} from 'chart.js'

// Register Chart.js components
Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    BarController
)

export default {
    name: 'PacketPerDayBarGraph',
    props: {
        chartdata: {
            type: Object,
            required: true,
            validator(value) {
                return value && value.datasets && Array.isArray(value.datasets)
            }
        }
    },
    setup(props) {
        const canvas = ref(null)
        const chartInstance = ref(null)

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    stacked: true,
                    title: {
                        display: true,
                        text: 'Days of the month',
                        font: {
                            size: 12
                        }
                    }
                },
                y: {
                    stacked: false
                }
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Packets in the last 30 days',
                    font: {
                        size: 15
                    }
                },
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            let label = context.dataset.label || ''
                            if (label) {
                                label += ': '
                            }
                            if (context.parsed.y !== null) {
                                label += context.parsed.y
                            }
                            return label
                        }
                    }
                },
                legend: {
                    position: 'top'
                }
            }
        }

        onMounted(() => {
            if (canvas.value) {
                chartInstance.value = new Chart(canvas.value, {
                    type: 'bar',
                    data: props.chartdata,
                    options: options
                })
                // console.log('Chart mounted successfully', {
                //   timestamp: new Date().toISOString(),
                //   dataPoints: props.chartdata?.datasets?.[0]?.data?.length || 0,
                //   points: props.chartdata?.datasets || []
                // })
            }
        })

        watch(
            () => props.chartdata,
            (newData) => {
                if (chartInstance.value) {
                    chartInstance.value.data = newData
                    chartInstance.value.update()
                    console.log('Chart data updated')
                }
            },
            { deep: true }
        )

        return { canvas }
    }
}
</script>

<style scoped>
.chart-container {
    position: relative;
    height: 400px;
}
</style>